var React = require('react');

function FaqInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#FEF1E9","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.1","d":"M8.33 8.33a2.67 2.67 0 113.56 2.52A1.33 1.33 0 0011 12.1V13","key":0}),React.createElement("path",{"fill":"#FEF1E9","stroke":"#FEF1E9","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.1","d":"M11 15.67a.33.33 0 100 .66.33.33 0 000-.66z","key":1}),React.createElement("path",{"stroke":"#FEF1E9","strokeMiterlimit":"10","strokeWidth":"1.1","d":"M1 11a10 10 0 1020 0 10 10 0 00-20 0v0z","key":2})]);
}

FaqInline.defaultProps = {"fill":"none","viewBox":"0 0 22 22"};

module.exports = FaqInline;

FaqInline.default = FaqInline;
